import type {Recommendation} from '../Recommendation.js'

export const groupOverlappingRecommendations = (recommendations: Recommendation[]): Recommendation[][] => {
  const sortedRecommendations = [...recommendations].sort((a, b) => timestamp(a.start) - timestamp(b.start))

  return sortedRecommendations.reduce((overlappingRecommendations, recommendation) => {
    const lastGroup = overlappingRecommendations.at(-1)
    const lastGroupRecommendation = lastGroup?.at(-1)

    // create new group
    if (
      !lastGroup ||
      !lastGroupRecommendation ||
      lastGroup.every((groupRecommendation) => timestamp(recommendation.start) >= timestamp(groupRecommendation.end))
    ) {
      return [...overlappingRecommendations, [recommendation]]
    }

    // add to last group
    lastGroup.push(recommendation)
    return overlappingRecommendations
  }, [] as Recommendation[][])
}

const timestamp = (date: string) => new Date(date).getTime()
